import React from "react";

const CapitalAbout = () => {
  return (
    <section className="about-section">
      <div className="container banner-div-top">
        <div className="row">
          <div className="col-lg-6">
            <div className="about-content about-content-2">
              <div className="about-border">
                <h1>Passion </h1>
                <img
                  src="assets/image/about-icon-2-1.png"
                  alt="About-Section"
                />
                <p>
                  {" "}
                  Nous sommes des passionnés qui désirent sincèrement changer le
                  monde un projet à la fois. Chaque matin, nous nous réveillons
                  animé d'une flamme intérieure qui nous pousse à nous dépasser
                  pour révolutionner la façon dont les développeurs immobiliers
                  créent et maintiennent le parc de logements québécois.
                </p>
              </div>
            </div>
            <div className="about-content about-content-2 about-inner">
              <div className="about-border">
                <h1>Engagement </h1>
                <img
                  src="assets/image/about-icon-2-3.png"
                  alt="About-Section"
                />
                <p>
                  Nous sommes pleinement dévoués et engagés dans
                  l'accomplissement et la réussite de chaque projet. Le succès,
                  le bonheur de nos partenaires et de nos clients sont au centre
                  de tout ce que nous entreprenons et cherchont à bâtir comme
                  entreprise et acteur d'influence dans le monde de
                  l'immobilier. Notre engagement envers chacun d'entre eux ne
                  peut tout simplement pas s'éteindre. Abandonner n'est jamais
                  une option.
                </p>
              </div>
            </div>
            <div className="about-content about-content-2 about-inner">
              <div className="about-border">
                <h1>Compassion  </h1>
                <img
                    src="assets/image/about-icon-2-2.png"
                    alt="About-Section"
                  />
                <p>
                Prendre soin des autres est au cœur de qui nous sommes comme entrepreneurs, mais avant tout comme individus. Nous savons identifier les endroits de besoins autour de nous et laisser notre cœur être saisi d'un désir profond de faire une différence concrète dans ces situations.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-bottom">
              <div className="about-content about-content-2">
                <div className="about-border">
                  <h1>Excellence </h1>
                  <img
                    src="assets/image/about-icon-2-2.png"
                    alt="About-Section"
                  />
                  <p>
                    Notre expertise est ancrée profondément dans notre volonté
                    de continuellement nous améliorer et développer de nouvelles
                    connaissances pour mieux vous servir. Nous avons étudié
                    pendant des années afin de faire partie de l'élite des
                    professionnels de la finance. Mais nous avons également
                    complété notre coffre à outils avec de l'expérience
                    concrète, forgée sur le terrains de projets immobiliers
                    complexes et porteurs qui ont affiné notre approche.
                  </p>
                </div>
              </div>
              <div className="about-content about-content-2">
                <div className="about-border">
                  <h1>Intégrité </h1>
                  <img
                    src="assets/image/about-icon-2-1.png"
                    alt="About-Section"
                  />
                  <p>
                    Face aux multitudes de situations délicates auxquelles les
                    investisseurs immobilier sont confrontés, vous pourrez
                    toujours compter sur notre transparence, notre soutien
                    indéfectible et nous accorder votre confiance la plus
                    totale. Notre intégrité est un rempart sur lequel toutes nos
                    relations long terme sont bâties.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-25vh"></div>
    </section>
  );
};

export default CapitalAbout;
